export class MegaMenu extends HTMLElement{
    constructor(){
        super();
        this.header = this.closest("header");
        this.initMegaMenu();
    }

    initMegaMenu() {
        let menuItems = this.header.querySelectorAll(".header_main > li");
        const showMega = (index) => {
            let megaDiv = this.header.querySelector(".mega_menu_list");
            let megaItem;
            if (megaDiv) {
                megaItem = megaDiv.querySelectorAll(`.mega-menu[data-mega="${index}"]`);
                for (let j = 0; j < megaItem.length; j++) {
                    if (index) {
                        return megaItem[j];
                    }
                }
            }
        };

        const showMobileMega = (index) => {
            let megaDiv = this.header.querySelector(".mega_menu_mobile");
            if (megaDiv) {
                let megaItem = megaDiv.querySelectorAll(`.mega-menu[data-mega="${index}"]`);
                for (let j = 0; j < megaItem.length; j++) {
                    let megaClose = megaItem[j].querySelector(".menu-back svg");
                    if (index) {
                        if (megaClose) {
                            megaClose.addEventListener("click", (e) => {
                                megaItem[j].classList.remove("mega-menu-active");
                            });
                        }
                        return megaItem[j];
                    }
                }
            }
        };

        const megaItems = () => {
            let megaItems = this.header.querySelectorAll(".parent-link > .child-menu-1.has-submenu");
            for (let p = 0; p < megaItems.length; p++) {
                megaItems[p].addEventListener("click", (e) => {
                    megaItems[p].querySelector(".child-link").classList.add("child-active");
                    let menuBack = megaItems[p].querySelector(".child-link .menu-back svg");
                    if (e.target == menuBack) {
                        megaItems[p].querySelector(".child-link").classList.remove("child-active");
                    }
                });
                megaItems[p].addEventListener("keyup", (e) => {
                    if (e.key == "Enter" || e.key == " ") {
                        megaItems[p].querySelector(".child-link").classList.add("child-active");
                        let menuBack = megaItems[p].querySelector(".child-link .menu-back");
                        if (e.target == menuBack) {
                            megaItems[p].querySelector(".child-link").classList.remove("child-active");
                        }
                    }
                });
            }
        };

        megaItems();

        for (let i = 0; i < menuItems.length; i++) {
            let index = menuItems[i].getAttribute("data-mega");
            switch (index) {
                case "1":
                    if (showMega("1")) {
                        menuItems[i].classList.add("mega-item-active");
                    }
                    break;
                case "2":
                    if (showMega("2")) {
                        menuItems[i].classList.add("mega-item-active");
                    }
                    break;
                case "3":
                    if (showMega("3")) {
                        menuItems[i].classList.add("mega-item-active");
                    }
                    break;
                case "4":
                    if (showMega("4")) {
                        menuItems[i].classList.add("mega-item-active");
                    }
                    break;
                case "5":
                    if (showMega("5")) {
                        menuItems[i].classList.add("mega-item-active");
                    }
                    break;
                case "6":
                    if (showMega("6")) {
                        menuItems[i].classList.add("mega-item-active");
                    }
                    break;
                default:
                    break;
            }

            menuItems[i].addEventListener("click", (e) => {
                let mobileIndex = e.target.getAttribute("data-mega");
                switch (mobileIndex) {
                    case "1":
                        if (showMobileMega("1")) {
                            showMobileMega("1").classList.add("mega-menu-active");
                        }
                        break;
                    case "2":
                        if (showMobileMega("2")) {
                            showMobileMega("2").classList.add("mega-menu-active");
                        }
                        break;
                    case "3":
                        if (showMobileMega("3")) {
                            showMobileMega("3").classList.add("mega-menu-active");
                        }
                        break;
                    case "4":
                        if (showMobileMega("4")) {
                            showMobileMega("4").classList.add("mega-menu-active");
                        }
                        break;
                    case "5":
                        if (showMobileMega("5")) {
                            showMobileMega("5").classList.add("mega-menu-active");
                        }
                        break;
                    case "6":
                        if (showMobileMega("6")) {
                            showMobileMega("6").classList.add("mega-menu-active");
                        }
                        break;
                    default:
                        break;
                }
            });
            
            menuItems[i].addEventListener("mouseenter", (e) => {
                let menuIndex = e.target.getAttribute("data-mega");
                switch (menuIndex) {
                    case "1":
                        if (showMega("1")) {
                            showMega("1").classList.add("mega-menu-active");
                        }
                        break;
                    case "2":
                        if (showMega("2")) {
                            showMega("2").classList.add("mega-menu-active");
                        }
                        break;
                    case "3":
                        if (showMega("3")) {
                            showMega("3").classList.add("mega-menu-active");
                        }
                        break;
                    case "4":
                        if (showMega("4")) {
                            showMega("4").classList.add("mega-menu-active");
                        }
                        break;
                    case "5":
                        if (showMega("5")) {
                            showMega("5").classList.add("mega-menu-active");
                        }
                        break;
                    case "6":
                        if (showMega("6")) {
                            showMega("6").classList.add("mega-menu-active");
                        }
                        break;
                    default:
                        break;
                }
            });

            menuItems[i].addEventListener("mouseleave", (e) => {
                let menuIndex = e.target.getAttribute("data-mega");
                switch (menuIndex) {
                    case "1":
                        if (showMega("1")) {
                            showMega("1").classList.remove("mega-menu-active");
                        }
                        break;
                    case "2":
                        if (showMega("2")) {
                            showMega("2").classList.remove("mega-menu-active");
                        }
                        break;
                    case "3":
                        if (showMega("3")) {
                            showMega("3").classList.remove("mega-menu-active");
                        }
                        break;
                    case "4":
                        if (showMega("4")) {
                            showMega("4").classList.remove("mega-menu-active");
                        }
                        break;
                    case "5":
                        if (showMega("5")) {
                            showMega("5").classList.remove("mega-menu-active");
                        }
                        break;
                    case "6":
                        if (showMega("6")) {
                            showMega("6").classList.remove("mega-menu-active");
                        }
                        break;
                    default:
                        break;
                }
            });

            menuItems[i].addEventListener("keyup", (e) => {
                let menuIndex = e.target.closest("li[data-mega]").getAttribute("data-mega");
                if (e.key == " ") {
                    switch (menuIndex) {
                        case "1":
                            if (showMega("1")) {
                                showMega("1").classList.add("mega-menu-active");
                                showMega("1").focus();
                            }
                            break;
                        case "2":
                            if (showMega("2")) {
                                showMega("2").classList.add("mega-menu-active");
                                showMega("2").focus();
                            }
                            break;
                        case "3":
                            if (showMega("3")) {
                                showMega("3").classList.add("mega-menu-active");
                                showMega("3").focus();
                            }
                            break;
                        case "4":
                            if (showMega("4")) {
                                showMega("4").classList.add("mega-menu-active");
                                showMega("4").focus();
                            }
                            break;
                        case "5":
                            if (showMega("5")) {
                                showMega("5").classList.add("mega-menu-active");
                                showMega("5").focus();
                            }
                            break;
                        case "6":
                            if (showMega("6")) {
                                showMega("6").classList.add("mega-menu-active");
                                showMega("6").focus();
                            }
                            break;
                        default:
                            break;
                    }
                }
            });
        }

        document.addEventListener("keyup", (e) => {
            if (e.key == "Escape") {
                this.header.querySelectorAll(".mega-menu-desktop").forEach(item => {
                    item.classList.remove("mega-menu-active");
                });
            }
        });
    }
}

if(!customElements.get("mega-menu")){
    customElements.define("mega-menu",MegaMenu)
}